<template>
  <div class="mb-5">
    <router-link
      class="background-color-seashell font-size-sm nav-button-border-radius pa-2"
      :to="{ name: 'account', hash: getHash(textContent) }"
    >
      {{ textContent }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "XsNavPill",
  methods: {
    getHash(nav) {
      const navToHashMap = {
        "Orders": "#orders",
        "My Profile": "#profile",
        About: "#about",
        Support: "#support",
      };
      return navToHashMap[nav] || "#profile";
    },
  },
  props: { textContent: String },
};
</script>
